<template>
  <v-footer app fixed height="auto" color="primary" class="py-1">
    <v-layout justify-center row wrap mx-0 my-0>
      <v-flex primary text-center white--text xs12>
        &copy; {{ new Date().getFullYear() }} - Telemedica Co., Ltd. All rights reserved
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
  name: 'Footer',
});
</script>
